import { ReactElement } from 'react';
import { EnergyConsumptionRegisterContainer, RegisterButton } from './styles';
import { ColumnsIcon, FilePlusIcon } from 'icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface EnergyConsumptionRegisterProps {
  clientId: number;
  onClickRegisterPlatform: () => void;
}

export function EnergyConsumptionRegister({
  clientId,
  onClickRegisterPlatform,
}: Readonly<EnergyConsumptionRegisterProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <EnergyConsumptionRegisterContainer>
      <RegisterButton
        onClick={onClickRegisterPlatform}
        type="button"
        variant="neutral-stroke-primary"
        style={{ width: '230px' }}
      >
        <>
          <FilePlusIcon size="14" />
          <span>{t('cadastrarMetaPelaPlataforma')}</span>
        </>
      </RegisterButton>
      <Link to={`/painel/clientes/editar-cliente/${clientId}/energia/cadastro-metas-planilha`}>
        <RegisterButton
          type="button"
          variant="neutral-stroke-primary"
        >
          <>
            <ColumnsIcon size="14" />
            <span>{t('cadastrarMetaPorPlanilha')}</span>
          </>
        </RegisterButton>
      </Link>
    </EnergyConsumptionRegisterContainer>
  );
}
